import axios from "axios";

import { IDefaultMessage } from "../../../pages/ConfiguracaoSimulador/interfaces";

import { urlHttpGov } from "../../urls";
import { getToken } from "../../LStorage/token";

class DefaultMessageService {
  private readonly baseURL = `${urlHttpGov}/simulador-inteligente/mensagem-padrao`;

  async create(message: Omit<IDefaultMessage, "_id">): Promise<IDefaultMessage> {
    const { data } = await axios.post(this.baseURL, message, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data;
  }

  async update(message: IDefaultMessage): Promise<IDefaultMessage> {
    const { data } = await axios.put(this.baseURL, message, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      }
    });

    return data;
  }

  async get(signal: AbortSignal): Promise<IDefaultMessage[]> {
    const { data } = await axios.get(this.baseURL, {
      headers: {
        'Authorization': 'Bearer ' + getToken()
      },
      signal
    });

    return data;
  }
}

export default new DefaultMessageService();
